import * as z from "zod";

/** Per-arm A/B counts for one merchant's active test. Sums to the pooled card. */
const abArm = z.object({
  enrolledCustomers: z.number(),
  dispatchesSent: z.number(),
  /** Dispatch-time routing decision, not confirmed handset delivery. */
  dispatchesViaImessage: z.number(),
  dispatchesViaSms: z.number(),
  customersWithReply: z.number(),
  replyCount: z.number(),
});

/** ISO date strings; omit entirely for all-time. */
const dateRange = z.object({
  start: z.string().min(1),
  end: z.string().min(1),
});

export const getShopperAgentAbMerchants = {
  name: "getShopperAgentAbMerchants" as const,
  // shopper-agent-enabled brands with their active imessage_channel A/B test counts
  // for `source` (the merchant table on the A/B page). Unlike the fleet metrics
  // table, these are A/B-test-scoped, so the rows reconcile with the pooled card.
  // Brands without an active test still appear (so a test can be started) with
  // null arm stats. Search, sort, and paging are client-side.
  input: z.object({
    source: z.enum(["concierge", "recover"]).optional(),
    dateRange: dateRange.optional(),
  }),
  output: z.object({
    merchants: z.array(
      z.object({
        teamId: z.string(),
        teamName: z.string(),
        hasActiveTest: z.boolean(),
        testName: z.string().nullable(),
        // Null when the brand has no active test on this surface.
        imessage: abArm.nullable(),
        smsForced: abArm.nullable(),
      }),
    ),
  }),
};
